import "./Title.scss";

export default function Title() {
  return <h1 className="title">IP Address Tracker</h1>;
}
